// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleButton_wrapper__ISzZu","secondary":"ToggleButton_secondary__+-Wuq","opened":"ToggleButton_opened__65Din","icon":"ToggleButton_icon__V1mEf"};